import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { handleGetPayment } from '../controllers/paymentController';

// Result page iyzico redirects back to (via our /api/payments/callback/):
//   /odeme/sonuc?status=success|failure&payment=<id>
export default function PaymentResultPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const statusParam = params.get('status');
  const paymentId   = params.get('payment');
  const [payment, setPayment] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  // Confirm details from the backend when we have an id and the user is logged in.
  useEffect(() => {
    if (!paymentId) return;
    (async () => {
      const res = await handleGetPayment(paymentId);
      if (res.success) setPayment(res.data);
    })();
  }, [paymentId]);

  // Trust the backend's payment record when we have it; otherwise the URL flag.
  const ok = payment ? payment.status === 'success' : statusParam === 'success';

  return (
    <div className="min-h-screen bg-gray-50"><Navbar />
      <div className="max-w-lg mx-auto px-6 pt-28 pb-20">
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 text-center">

          {ok ? (
            <>
              <div className="w-16 h-16 rounded-full bg-green-100 text-green-600 text-3xl flex items-center justify-center mx-auto mb-5">
                ✓
              </div>
              <h1 className="text-xl font-bold text-gray-900 mb-2">Ödemeniz alındı</h1>
              <p className="text-sm text-gray-500 mb-6">
                Ödemeniz başarıyla gerçekleşti. Tedarikçi bilgilendirildi ve süreç başlatıldı.
              </p>
            </>
          ) : (
            <>
              <div className="w-16 h-16 rounded-full bg-red-100 text-red-600 text-3xl flex items-center justify-center mx-auto mb-5">
                ✕
              </div>
              <h1 className="text-xl font-bold text-gray-900 mb-2">Ödeme tamamlanamadı</h1>
              <p className="text-sm text-gray-500 mb-2">
                Ödemeniz alınamadı veya işlem iptal edildi. Tutar hesabınızdan çekilmez.
              </p>
              {payment?.error_message && (
                <p className="text-xs text-red-500 mb-4">{payment.error_message}</p>
              )}
              <p className="text-sm text-gray-500 mb-6">Dilerseniz tekrar deneyebilirsiniz.</p>
            </>
          )}

          {payment && (
            <div className="bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 mb-6 text-left text-sm space-y-1">
              <div className="flex justify-between">
                <span className="text-gray-400">Tutar</span>
                <span className="font-semibold text-gray-800">
                  ₺{parseFloat(payment.paid_price || payment.price).toLocaleString('tr-TR')}
                </span>
              </div>
              {ok && payment.payment_id && (
                <div className="flex justify-between">
                  <span className="text-gray-400">İşlem No</span>
                  <span className="font-mono text-xs text-gray-600">{payment.payment_id}</span>
                </div>
              )}
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3">
            <button onClick={() => navigate('/dashboard/customer')}
              className="flex-1 bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold py-3 rounded-xl transition">
              Panele Dön
            </button>
            {!ok && (
              <button onClick={() => navigate('/dashboard/customer')}
                className="flex-1 border border-gray-200 text-gray-600 text-sm font-semibold py-3 rounded-xl hover:border-blue-400 hover:text-blue-700 transition">
                Tekliflere Git
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
